import React, {Component} from 'react';
import {withRouter} from "react-router";
import {translate} from 'react-i18next';
import reviewEn from '../../i18n/locales/en/review.json'

class Rate extends Component {
  render() {
    const {t} = this.props;
    return (
      <div className={'rate-bar vertical-center'}>
        <div className={'center'}>
          <div className={'max-width advantages-pre-container'}>
            <h2>{t('rate.title')}</h2>
            <div className={'h-text2-last'}>
              <a className={'read-more'} target={'_new'}
                 href={"https://www.trustpilot.com/review/solarcom.ch"}>{t('rate.link')}</a>
            </div>
            <div className={'rate-container'}>
              {reviewEn.reviews.map(item => <Block item={item} {...this.props}/>)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(translate('home')(Rate));

class Block extends Component {

  render() {
    const {item, t} = this.props;
    const stars = [];
    for (let i = 0; i < item.rate; i++) {
      stars.push(<div className={'star'} key={i}/>);
    }
    return (
      <div className={'item box'}>
        <div className={'star-container'}>
          {stars}
        </div>
        <div className={'title'}>{item.name}</div>
        <br/>
        {/*<div className={'title'}>{item.title}</div>*/}
        <div className={'text'}>{item.text.substring(0, 160)}...</div>
        <a className={'read-more'} target={'_new'}
           href={'https://www.trustpilot.com/reviews/' + item.url}>{t('rate.url')}</a>

      </div>
    )
  }
}

